import _ from 'lodash';
import initialState from '../initialstate';
import * as types from '../../actions/actiontypes';
import {HttpStatusCodes} from '../../util/uiconstants';

export default function getAllProjectsReducer(state = initialState.allProjects, action) {
	switch (action.type) {
		case types.GET_ALL_PROJECTS: {
			return action.response?.sort(function(a, b) {
				return a?.name?.localeCompare(b?.name);
			});
		}
		case types.CLEAR_ALL_PROJECTS: {
			return initialState.allProjects;
		}
		case types.MARK_COMPLETE_PROJECT: {
			if (typeof action.response === 'string') {
				const updatedProjectId = action.response;
				let currentState = _.cloneDeep(state);
				var updatedProject = currentState.find((p) => p.projectId == updatedProjectId);
				updatedProject.status = 'completed';
				return currentState;
			} else {
				return state;
			}
		}
		case types.DELETE_PROJECT:
		case types.REMOVE_PROJECT: {
			if (action?.responseObj?.request?.status === HttpStatusCodes.NoContent) {
				let projects = _.cloneDeep(state);
				const withoutDeleted = projects.filter((p) => p.projectId !== action.projectId);

				return withoutDeleted;
			}
			return state;
		}
		default:
			return state;
	}
}
